var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFilterOff = function SvgFilterOff(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.075 21.9-17-16.975q-.3-.3-.3-.713 0-.412.3-.712t.713-.3.712.3l17 17q.3.3.3.7t-.3.7-.712.3a.97.97 0 0 1-.713-.3m-3.25-8.9-2-2H17q.424 0 .712.287.288.288.288.713 0 .424-.288.713A.97.97 0 0 1 17 13zm-5-5-2-2H20q.424 0 .712.287Q21 6.575 21 7q0 .424-.288.712A.97.97 0 0 1 20 8zM11 18a.97.97 0 0 1-.713-.288A.97.97 0 0 1 10 17q0-.424.287-.712A.97.97 0 0 1 11 16h2q.424 0 .713.288.287.287.287.712 0 .424-.287.712A.97.97 0 0 1 13 18zm-.85-5H7a.97.97 0 0 1-.712-.287A.97.97 0 0 1 6 12q0-.424.288-.713A.97.97 0 0 1 7 11h3.15zm-5-5H4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 7q0-.424.288-.713A.97.97 0 0 1 4 6h1.15z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFilterOff);
export { ForwardRef as ReactComponent };